module.exports = __webpack_public_path__ + "img/tu3.4b8c3d2b.png";